module.exports = __webpack_public_path__ + "assets/img/most_like.0f4f49b7.svg";